const concatAddressLine2 = (line1: string, line2: string | undefined) => {
	return line1 + (line2 ? " " + line2 : "");
};

export default concatAddressLine2;
